import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { useSwipeable } from "react-swipeable";

import { handleReactRef } from "../../utils/react";

const Swipeable = forwardRef((props, ref) => {
  const {
    children, className, style, onClick,
    onMouseMove, onTouchStart, onTouchEnd, onTouchCancel, onTouchMove,
    onScroll,
    dataAttrs,
    tag: Tag = "div",
    ...hookProps
  } = props;

  const handlers = useSwipeable({
    ...hookProps,
  });

  return (
    <Tag
      ref={(el) => {
        handleReactRef(ref, el);

        handlers.ref(el);
      }}
      className={className}
      style={style}
      onClick={onClick}
      onScroll={onScroll}
      onMouseMove={onMouseMove}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      onTouchMove={onTouchMove}
      {...dataAttrs}
    >{children}</Tag>
  );
});

Swipeable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Swipeable;
